/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_No_IssuesInputs */

const cs_ebr_no_issues = /** @type {(inputs: Ebr_No_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádná upozornění.`)
};

const en_ebr_no_issues = /** @type {(inputs: Ebr_No_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No issues.`)
};

/**
* | output |
* | --- |
* | "No issues." |
*
* @param {Ebr_No_IssuesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_no_issues = /** @type {((inputs?: Ebr_No_IssuesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_No_IssuesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_no_issues(inputs)
	return cs_ebr_no_issues(inputs)
});